// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__t-8Ao","consentsList":"PatientConsents_consentsList__3_zfn","consentsListEmpty":"PatientConsents_consentsListEmpty__nATQg"};